import { Vector3 } from 'three';
import { CONFIG } from '../config.js';
import { shiftToComFrame } from '../physics/com.js';
import { CelestialBody } from './CelestialBody.js';

function randRange(a, b) {
  return a + Math.random() * (b - a);
}

export function createRandomBodies(scene, glowTexture, config = CONFIG) {
  const list = [];
  const starColors = [0xffeb3b, 0xffcc80, 0xfff59d];
  const starNames = ['恒星 α', '恒星 β', '恒星 γ'];

  for (let i = 0; i < 3; i++) {
    const mass = randRange(0.8, 1.5);
    list.push(
      new CelestialBody(
        {
          id: 'star-' + i,
          name: starNames[i],
          mass,
          position: new Vector3(randRange(-3, 3), randRange(-3, 3), randRange(-3, 3)),
          velocity: new Vector3(randRange(-0.6, 0.6), randRange(-0.6, 0.6), randRange(-0.6, 0.6)),
          color: starColors[i],
          radius: 0.45 + 0.15 * mass,
          isStar: true,
        },
        scene,
        glowTexture,
      ),
    );
  }

  list.push(
    new CelestialBody(
      {
        id: 'planet',
        name: 'Trisolaris',
        mass: config.PLANET_MASS * randRange(0.8, 1.2),
        position: new Vector3(randRange(-2, 2), randRange(-2, 2), randRange(-2, 2)),
        velocity: new Vector3(randRange(-0.4, 0.4), randRange(-0.4, 0.4), randRange(-0.4, 0.4)),
        color: 0x4fc3f7,
        radius: 0.25,
        isStar: false,
      },
      scene,
      glowTexture,
    ),
  );

  shiftToComFrame(list);
  for (let i = 0; i < list.length; i++) list[i].updateMesh();
  return list;
}

export function disposeBodies(list) {
  for (let i = 0; i < list.length; i++) list[i].dispose();
  return [];
}
